import { useCallback, useEffect, useState, Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MenuCM from "components/shared/menu";
import ProfileMenuCM from "components/profilemenu";
import FooterCM from "components/shared/footer";
import { Button } from "@mui/material";
import { Select, MenuItem, Container } from "@mui/material";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteModal from "components/shared/Modal/Delete";
import { StyledCardContent } from "./Edit.style";
import {
  updateUserAddressRequest,
  getUserAddressByIdRequest,
  deleteUserAddressRequest,
} from "api/requests";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { EditAddressSchema } from "validations";
import Toast from "helper/toast";
import { provinces } from "constants/provinces";
import { cities } from "constants/cities";
import CheckIcon from "@mui/icons-material/Check";
import { FaPhoneSquare } from "react-icons/fa";
import { AiFillMail } from "react-icons/ai";
import { ImEarth } from "react-icons/im";
import { GoLocation } from "react-icons/go";
import {Helmet} from "react-helmet";

////////////////////////////
const formList = [
  // {
  //   label: "استان",
  //   type: "text",
  //   id: "state",
  //   icon: <ImEarth />,
  // },
  // {
  //   label: "شهر",
  //   type: "text",
  //   id: "city",
  //   icon: <GoLocation />,
  // },
  {
    label: "کد پستی",
    type: "text",
    id: "postal_code",
    icon: <AiFillMail />,
  },
  {
    label: "آدرس",
    type: "text",
    id: "address",
    icon: <GoLocation />,
  },
];

export default function Editaddress() {
  const params = useParams();
  const { request, loading, setLoading } = useHttp(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(EditAddressSchema),
  });
  const [userData, setUserData] = useState("");
  const [selectedState, setSelectedState] = useState({});
  const [selectedCity, setSelectedCity] = useState({});

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handelShowModal = () => setShowDeleteModal((state) => !state);

  const getAddress = useCallback(async () => {
    setLoading(true);
    let res = await request({
      url: getUserAddressByIdRequest,
      values: params.addressId,
    });
    setUserData(res);
    setLoading(false);

    if (res) {
      reset({
        state: res.state,
        city: res.city,
        postal_code: res.postal_code,
        address: res.address,
      });
    }
    if (res?.user?.type == "colleague") {
      navigate("/");
    }
  }, [request, params.addressId, reset]);

  useEffect(() => {
    getAddress();
  }, [getAddress]);

  const onSubmit = async (values) => {
    values.id = params.addressId;

    const res = await request({
      url: updateUserAddressRequest,
      values,
    });

    if (res) {
      Toast({ type: "success", title: "ویرایش آدرس" });
    }
  };

  const handelDelete = async () => {
    const res = await request({
      url: deleteUserAddressRequest,
      values: params.addressId,
    });
    if (res) Toast({ type: "success", title: "حذف" });
    navigate("/address");
  };

  return (
    <>
      <Helmet>
        <title>ویرایش آدرس - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      {loading ? (
        <LoadingCM />
      ) : (
        <>
          <MenuCM Background pageTitle="ویرایش آدرس" />
          <Container>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <ProfileMenuCM />
              </Grid>
              <Grid item xs={12} sm={12} md={9} lg={9} mb={10}>
                <Paper p={2}>
                  <StyledCardContent>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "21px",
                      }}
                    >
                      ویرایش آدرس
                    </Typography>
                  </StyledCardContent>
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid item md={6} xs={12} p={1.5}>
                        <TextField
                          id="state"
                          select
                          label="استان"
                          size="small"
                          fullWidth
                          value={selectedState?.name}
                          defaultValue={userData?.state}
                          {...register("state")}
                          error={Boolean(errors.state)}
                          helperText={errors.state?.message}
                          onChange={(e) =>
                            setSelectedState({
                              name: e.target.value,
                            })
                          }
                          variant="standard"
                        >
                          {provinces.data?.map((item, index) => (
                            <MenuItem
                              key={index}
                              value={item.name}
                              style={{
                                direction: "rtl",
                              }}
                            >
                              {item.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item md={6} xs={12} p={1.5}>
                        <TextField
                          id="city"
                          select
                          label="شهر"
                          size="small"
                          fullWidth
                          value={selectedCity?.name}
                          defaultValue={userData?.city}
                          {...register("city")}
                          error={Boolean(errors.city)}
                          helperText={errors.city?.message}
                          onChange={(e) =>
                            setSelectedCity({
                              name: e.target.name,
                            })
                          }
                          // helperText="Please select your currency"
                          variant="standard"
                        >
                          {cities.data
                            ?.filter(
                              (item) =>
                                item.province_id ===
                                provinces.data?.find((item) =>
                                  selectedState.name === undefined
                                    ? item.name === userData.state
                                    : item.name === selectedState.name
                                )?.id
                            )
                            .map((item, index) => (
                              <MenuItem
                                key={index}
                                value={item.name}
                                style={{
                                  direction: "rtl",
                                }}
                              >
                                {item.name}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>

                      {formList.map((items, index) => (
                        <Grid
                          item
                          md={12}
                          xs={12}
                          p={1.5}
                          key={"profile" + index}
                        >
                          <FormControl fullWidth variant="standard">
                            <InputLabel>{items.label}</InputLabel>
                            <Input
                              id={items.id}
                              label={items.label}
                              variant="outlined"
                              required={items.required}
                              fullWidth
                              {...register(items.id)}
                              readOnly={items.readOnly}
                              error={Boolean(errors[items.id])}
                              startAdornment={
                                <InputAdornment position="start">
                                  {items.icon}
                                </InputAdornment>
                              }
                            />
                            <FormHelperText id={items.id}>
                              {errors[items.id]?.message}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                      ))}
                      <Grid
                        item
                        md={12}
                        xs={12}
                        style={{ direction: "ltr", paddingTop: "0px" }}
                      >
                        <Button
                          color="error"
                          startIcon={<DeleteIcon />}
                          variant="contained"
                          sx={{ mt: 1, mr: 1 }}
                          onClick={handelShowModal}
                          style={{ direction: "rtl" }}
                        >
                          حذف
                        </Button>
                        <Button
                          color="success"
                          startIcon={<CheckIcon />}
                          variant="contained"
                          sx={{ mt: 1, mr: 1 }}
                          onClick={handleSubmit(onSubmit)}
                          style={{ direction: "rtl" }}
                        >
                          ویرایش آدرس
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Paper>
              </Grid>
            </Grid>
          </Container>
          <DeleteModal
            show={showDeleteModal}
            onClose={handelShowModal}
            onDelete={handelDelete}
          />
          <FooterCM />
        </>
      )}
    </>
  );
}
